import React from 'react';
import type { EventDto, EventKind } from './types';
import { toEventKind } from './types';
import { EventMeetingModalContent } from './EventMeetingModalContent';
import { EventAnnouncementModalContent } from './EventAnnouncementModalContent';
import type { EventImageUrlResolver } from './EventBody';

export interface EventKindModalProps {
    readonly event: EventDto;
    readonly resolveImageUrls?: EventImageUrlResolver;
}

export type EventModalContentProps = EventKindModalProps;

// A new kind is a row here, not a new branch: every consumer renders
// `EventModalContent` and gets that kind's pop-up.
const EVENT_KIND_MODALS: Record<EventKind, React.FC<EventKindModalProps>> = {
    meeting: EventMeetingModalContent,
    announcement: EventAnnouncementModalContent
};

export const EventModalContent: React.FC<EventModalContentProps> = ({
    event,
    resolveImageUrls
}) => {
    const Content = EVENT_KIND_MODALS[toEventKind(event.kind)];
    return <Content event={event} resolveImageUrls={resolveImageUrls} />;
};

export default EventModalContent;
